import React from "react";
import LabelParameters from "../LabelParameters";
import { useTranslation } from "react-i18next";
import styles from '../CreateParameterPopup.module.css'

const Formula = ({
    parameterData,
    setParameterData,
    handleChange,
    editingInput,
    setEditingInput,
    setShowAddTags,
  }) => {
  const [t] = useTranslation("Contacts");

  const handleKeyDown = (e) => {
    if (e.altKey || e.ctrlKey) {
      e.stopPropagation();
    }
  };

  return (
    <div className={styles.formulaContainer}>
    <p>{t("formula")}</p>
    <div>
      <span>{t("use@ToAddNumbers")}</span>
      <input
        type="text"
        placeholder="@"
        onChange={(e) =>
          setParameterData((prev) => ({
            ...prev,
            formula: e.target.value,
          }))
        }
        onKeyDown={handleKeyDown}
        value={parameterData?.formula}
      />
    </div>
  </div>
  )
}

export default Formula